/**
 * MaturityChart — Barras horizontais para Maturidade dos Canais
 * Iniciante / Operacional / Estratégico
 */
interface MaturityLevel {
  level: string;
  count: number;
  color: string;
}

interface MaturityChartProps {
  data: MaturityLevel[];
  title?: string;
}

export default function MaturityChart({ data, title = "Maturidade dos Canais" }: MaturityChartProps) {
  if (!data || data.length === 0) return null;
  const total = data.reduce((s, d) => s + d.count, 0);

  return (
    <div>
      {title && <h3 className="text-sm font-semibold text-[#002F59] mb-4">{title}</h3>}
      <div className="space-y-4">
        {data.map((level, i) => {
          const pct = total > 0 ? Math.round((level.count / total) * 100) : 0;
          return (
            <div key={i}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium" style={{ color: level.color }}>{level.level}</span>
                <span className="text-sm font-bold" style={{ color: level.color }}>
                  {level.count} ({pct}%)
                </span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-3">
                <div
                  className="h-3 rounded-full transition-all duration-500"
                  style={{ width: `${pct}%`, backgroundColor: level.color, minWidth: level.count > 0 ? "12px" : "0" }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground mt-3 text-center">
        Total: {total} canais
      </p>
    </div>
  );
}
